import React, { useMemo } from "react";
import AppShell from "../../common/shell/AppShell";
import {
  adminRoutes,
  adminSidebarTabs,
  findAdminRouteByPathname,
} from "../../common/routes/routesConfig";  

export default function AdminPage() {
  const tabs = useMemo(() => adminSidebarTabs(), []);

  return (
    <AppShell
      basePath="/admin"
      tabs={tabs}
      routes={adminRoutes}         
      isAdmin={true}               
      titleResolver={(p) => findAdminRouteByPathname(p)?.label || "Admin"}
      getActivePath={(p) => p.replace(/^\/admin\/?/, "").split("/")[0] || ""}
    />
  );
}
